import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = {
  for: "name",
  class: "block mb-3 mt-4 text-sm font-medium text-gray-900 dark:text-white"
}
const _hoisted_3 = { class: "w-full inline-flex items-space-between mt-2" }
const _hoisted_4 = { class: "w-1/2 mr-2" }
const _hoisted_5 = {
  for: "inizioGravidanza",
  class: "block mb-3 mt-4 text-sm font-medium text-gray-900 dark:text-white"
}
const _hoisted_6 = { class: "w-1/2" }
const _hoisted_7 = {
  for: "fineGravidanza",
  class: "block mb-3 mt-4 text-sm font-medium text-gray-900 dark:text-white"
}
const _hoisted_8 = { class: "w-full inline-flex items-space-between mt-2" }
const _hoisted_9 = { class: "w-1/2 mr-2" }
const _hoisted_10 = {
  for: "etaBambino",
  class: "block mb-3 mt-4 text-sm font-medium text-gray-900 dark:text-white"
}
const _hoisted_11 = { class: "w-1/2 mr-2" }
const _hoisted_12 = {
  for: "esito",
  class: "block mb-3 mt-4 text-sm font-medium text-gray-900 dark:text-white"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("option", { value: "" }, null, -1)
const _hoisted_14 = { value: "nascita" }
const _hoisted_15 = { value: "aborto" }
const _hoisted_16 = { class: "w-1/2" }
const _hoisted_17 = {
  for: "sessoBambino",
  class: "block mb-3 mt-4 text-sm font-medium text-gray-900 dark:text-white"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("option", { value: "" }, null, -1)
const _hoisted_19 = { value: "Maschio" }
const _hoisted_20 = { value: "Femmina" }
const _hoisted_21 = {
  for: "noteGravidanza",
  class: "block mb-3 mt-4 text-sm font-medium text-gray-900 dark:text-white"
}
const _hoisted_22 = { class: "flex justify-between" }

import { storeToRefs } from 'pinia';
import { patientStore } from '@/store/patient';

import {useRoute} from 'vue-router';
import { tbl_gravidanze } from '../../../../EshJSLib/models/patient';


export default /*#__PURE__*/_defineComponent({
  __name: 'GravidanzaEdit',
  props: {
    id: {}
  },
  emits: ["closeGravidanze", "updateGravidanza"],
  setup(__props: any, { emit }) {

const props = __props;

const store = patientStore();
const Route = useRoute();
const { patient } = storeToRefs(store)

function Save(gravidanze : tbl_gravidanze) {
  emit('updateGravidanza',gravidanze);
}


    

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", _hoisted_2, [
      _createElementVNode("h3", null, _toDisplayString(_ctx.$t("Modifica gravidanze:")), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.$t("Inizio gravidanza :")), 1),
        _withDirectives(_createElementVNode("input", {
          id: "inizioGravidanza",
          ref: "inizioGravidanza",
          type: "date",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(patient).tbl_gravidanze[_ctx.id].inizio_gravidanza) = $event)),
          class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
        }, null, 512), [
          [_vModelText, _unref(patient).tbl_gravidanze[_ctx.id].inizio_gravidanza]
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.$t("Fine gravidanza :")), 1),
        _withDirectives(_createElementVNode("input", {
          id: "fineGravidanza",
          ref: "fineGravidanza",
          type: "date",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(patient).tbl_gravidanze[_ctx.id].fine_gravidanza) = $event)),
          class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
        }, null, 512), [
          [_vModelText, _unref(patient).tbl_gravidanze[_ctx.id].fine_gravidanza]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t("ETÀ :")), 1),
        _withDirectives(_createElementVNode("input", {
          ref: "etaGrav",
          type: "number",
          min: "1",
          id: "etaBambino",
          class: "w-full bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
          placeholder: "ETÀ",
          required: "",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(patient).tbl_gravidanze[_ctx.id].eta) = $event))
        }, null, 512), [
          [_vModelText, _unref(patient).tbl_gravidanze[_ctx.id].eta]
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.$t("Esito :")), 1),
        _withDirectives(_createElementVNode("select", {
          id: "esito",
          ref: "essito",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(patient).tbl_gravidanze[_ctx.id].esito) = $event)),
          name: "essito",
          class: "w-full bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
        }, [
          _hoisted_13,
          _createElementVNode("option", _hoisted_14, _toDisplayString(_ctx.$t("nascita")), 1),
          _createElementVNode("option", _hoisted_15, _toDisplayString(_ctx.$t("aborto")), 1)
        ], 512), [
          [_vModelSelect, _unref(patient).tbl_gravidanze[_ctx.id].esito]
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.$t("Sesso bambino :")), 1),
        _withDirectives(_createElementVNode("select", {
          id: "sessoBambino",
          ref: "sessoBambino",
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(patient).tbl_gravidanze[_ctx.id].sesso_bambino) = $event)),
          name: "sessoBamino",
          class: "w-full bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
        }, [
          _hoisted_18,
          _createElementVNode("option", _hoisted_19, _toDisplayString(_ctx.$t("Maschio")), 1),
          _createElementVNode("option", _hoisted_20, _toDisplayString(_ctx.$t("Femmina")), 1)
        ], 512), [
          [_vModelSelect, _unref(patient).tbl_gravidanze[_ctx.id].sesso_bambino]
        ])
      ])
    ]),
    _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.$t("Note gravidanza :")), 1),
    _withDirectives(_createElementVNode("textarea", {
      id: "noteGravidanza",
      ref: "noteGravidanza",
      rows: "2",
      class: "block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(patient).tbl_gravidanze[_ctx.id].note_gravidanza) = $event)),
      placeholder: ""
    }, null, 512), [
      [_vModelText, _unref(patient).tbl_gravidanze[_ctx.id].note_gravidanza]
    ]),
    _createElementVNode("div", _hoisted_22, [
      _createElementVNode("button", {
        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('closeGravidanze'))),
        type: "button",
        class: "mt-4 text-gray-500 bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-blue-300 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600"
      }, _toDisplayString(_ctx.$t("Annulla")), 1),
      _createElementVNode("button", {
        type: "button",
        onClick: _cache[7] || (_cache[7] = ($event: any) => (Save(_unref(patient).tbl_gravidanze[_ctx.id]))),
        style: {"float":"right","background-color":"#1A576E"},
        class: "mt-4 text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
      }, _toDisplayString(_ctx.$t("Salva")), 1)
    ])
  ]))
}
}

})